import { BlockHeader } from './header/Header'

import { BlockContent } from './BlockContent'
import { BlockListRoot, BlockMain } from './BlockList'
import { TypographyContentTitle } from './TypographyContentTitle'

export { BlockContentContext } from './BlockContent'
export { BlockListContext } from './BlockList'

export type {
  BlockAccordionProps,
  BlockContentProps,
  BlockItemProps,
  BlockProps,
  BlockHeaderBlocksTypes,
  BlockHeaderCheckboxProps,
  BlockHeaderProps,
  BlockHeaderSectionContentProps,
  BlockSize,
  BlockLayoutVariant,
  BlockWrapperProps,
} from './types'

export type { TypographyContentTitleProps } from './TypographyContentTitle'

/**
 * Block component with attached sub-components
 *
 * Usage:
 * - Standalone: <Block><Block.Title>...</Block.Title><Block.Content>...</Block.Content></Block>
 * - Multiple: <Block.List><Block>...</Block><Block>...</Block></Block.List>
 * - Content separator: <Block.ContentTitle>Section Name</Block.ContentTitle>
 */
export const Block = Object.assign(BlockMain, {
  List: BlockListRoot,
  Title: BlockHeader,
  Content: BlockContent,
  ContentTitle: TypographyContentTitle,
})
